import { useEffect, useState } from 'react';
import type { LogisticsCalculationPublicDto } from '@magimp/shared';
import { resolvePublicLogisticsCalculation } from './public-api.js';

type PublicState =
  | { status: 'loading' }
  | { status: 'ready'; dto: LogisticsCalculationPublicDto }
  | { status: 'notFound' };

export function usePublicLogisticsCalculation(token: string | null): PublicState {
  const [state, setState] = useState<PublicState>(
    token ? { status: 'loading' } : { status: 'notFound' },
  );

  useEffect(() => {
    if (!token) {
      setState({ status: 'notFound' });
      return;
    }
    let active = true;
    resolvePublicLogisticsCalculation(token)
      .then((dto) => {
        if (active) setState({ status: 'ready', dto });
      })
      .catch(() => {
        if (active) setState({ status: 'notFound' });
      });
    return () => {
      active = false;
    };
  }, [token]);

  return state;
}
